module.exports = __webpack_public_path__ + "media/images/CoachingSystemLine-ce5d80a60126cbc5f506ffd045647fe3.png";